import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { Box, Typography } from '@mui/material';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

function AppWrapper() {
  useEffect(() => {
    // Conditionally load the script
    if (process.env.REACT_APP_ENV === 'staging') {
      const script = document.createElement('script');
      script.defer = true;
      script.src = 'https://cloud.umami.is/script.js';
      script.dataset.websiteId = 'e25c78eb-3909-4af4-a4d6-24ae5116142b';
      document.head.appendChild(script);
    }
  }, []); // Empty dependency array ensures this runs only once

  return (
    <React.StrictMode>
      {process.env.REACT_APP_ENV !== 'production' && (
        <Box
          sx={{
            backgroundColor: 'red',
            position: 'fixed',
            top: 0,
            left: '50%',
            zIndex: 9999,
            translate: '-50%',
            width: '60dvw',
            textAlign: 'center',
            borderRadius: '0 0 10px 10px',
            height: '30px',
            boxSizing: 'border-box',
          }}
        >
          <Typography
            sx={{
              m: 0,
              p: 0,
            }}
          >
            !This is not production! It is:{' '}
            <Typography
              component="span"
              sx={{
                textDecoration: 'underline',
              }}
            >
              {process.env.REACT_APP_ENV}
            </Typography>
          </Typography>
        </Box>
      )}
      <App />
    </React.StrictMode>
  );
}

root.render(<AppWrapper />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
